module.exports = __webpack_public_path__ + "img/svg/background-competitions-empty.a70aa63029e0fe7cd590c6a4a961f2d1.svg";